export const environment = {
    production: true,
    VERSION : "31791"
};